import { Outlet, NavLink, Link } from "react-router-dom";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import project_logo from "../../assets/logo_project.png";
import { Text } from "@fluentui/react";
import { Delete24Regular } from "@fluentui/react-icons";
import styles from "./Layout.module.css";

interface Props {
    backgroundImageChanged?: boolean;
    onClick?: () => void;
    onRestartConversation?: () => void; 
    disabled?: boolean;
    className?: string;
}

// Custom Back Arrow Component
const BackArrow = () => (
    <svg 
        width="48" 
        height="48" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '8px',
            backgroundColor: 'transparent'
        }}
        className={styles.backArrow}
        onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(20, 129, 129, 0.1)';
            e.currentTarget.style.transform = 'translateX(-3px) scale(1.05)';
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.transform = 'translateX(0) scale(1)';
        }}
        onMouseDown={(e) => {
            e.currentTarget.style.transform = 'translateX(-2px) scale(0.95)';
        }}
        onMouseUp={(e) => {
            e.currentTarget.style.transform = 'translateX(-3px) scale(1.05)';
        }}
    >
        <path 
            d="M19 12H5M12 19L5 12L12 5" 
            stroke="#148181" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            style={{
                transition: 'stroke 0.3s ease'
            }}
        />
    </svg>
);

const Layout = ({ onRestartConversation }: Props) => { 
    
    const navigate = useNavigate();

    const logOut = () => {
        sessionStorage.clear();
        navigate("/auth");
    };

    return (
        <div className={styles.layout}>
            <header className={`${styles.header} ${ styles["header-custom-background"]}`} role={"banner"}>
                <div className={styles.headerContainer}>
                    <div className={styles.leftContainer}>
                        <Link to="/" className={styles.headerTitleContainer}>
                            <BackArrow />
                        </Link>
                    </div>
                    <div className={styles.rightContainer}>
                        <div className={`${styles.container}`} onClick={onRestartConversation}>
                            <Delete24Regular style={{color: "black"}} />
                            <Text className={styles.clearChatText}>{"Clear chat"}</Text>
                        </div>
                        <button className={styles.commandButton2} onClick={logOut}>
                            Cerrar sesión
                        </button>
                    </div>
                </div>
            </header>
        </div>
    );
};

export default Layout;
